export default __webpack_public_path__ + "static/img_growing_together_2-46e197fcb891e05c5195afadd2d0d22c.png";